import React from 'react'

const InvoiceCardSelectorCard = ({ card, index, selectedCardIndex, setSelectedCardIndex }) => {
  return (
    <div className={"card-tab" + (index === selectedCardIndex ? " active" : "")} data-card={`card${index}`} key={index} onClick={() => setSelectedCardIndex(index)}>
      <div className="card-tab-icon">{card.cardholder[0]}</div>
      <div className="card-tab-info">
        <div className="card-tab-title">{card.isDependent ? "Dependente" : "Titular"}</div>
        <div className="card-tab-subtitle">{card.cardholder}</div>
      </div>
    </div>
  )
}

export default InvoiceCardSelectorCard
